module.exports = __webpack_public_path__ + "static/media/i_v student2.fadd57d5.svg";